import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import { forumHome } from '../utils/portal';
/** Mono-caps trail "ФОРУМ / ТАРО / РАСКЛАДЫ", as on the portal. The last crumb is the current page. */
export default class Breadcrumbs extends Component {
  view() {
    const items = [{
      label: app.translator.trans('tarotportal-theme.forum.section.breadcrumb_home', {}, true),
      href: forumHome()
    }, ...this.attrs.items];
    return m("nav", {
      className: "TpCrumbs",
      "aria-label": "breadcrumbs"
    }, items.map((crumb, i) => [i > 0 && m("span", {
      className: "TpCrumbs-sep",
      "aria-hidden": "true"
    }, "/"), crumb.href && i < items.length - 1 ? m(Link, {
      href: crumb.href
    }, crumb.label) : m("span", {
      "aria-current": "page"
    }, crumb.label)]));
  }
}
flarum.reg.add('tarotportal-theme', 'forum/components/Breadcrumbs', Breadcrumbs);